import { render, staticRenderFns } from "./AddItemsDocument.vue?vue&type=template&id=df710354&scoped=true&"
import script from "./AddItemsDocument.vue?vue&type=script&lang=js&"
export * from "./AddItemsDocument.vue?vue&type=script&lang=js&"
import style0 from "./AddItemsDocument.vue?vue&type=style&index=0&id=df710354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df710354",
  null
  
)

export default component.exports